import moment from 'moment';
export class OblOiService {
    OblOrdemintervencao;
    OblOrdemintervencaoEstado;
    OblOrdemintervencaoAlteracaoestado;
    AuthenticationService;
    constructor(OblOrdemintervencao, OblOrdemintervencaoEstado, OblOrdemintervencaoAlteracaoestado, AuthenticationService) {
        this.OblOrdemintervencao = OblOrdemintervencao;
        this.OblOrdemintervencaoEstado = OblOrdemintervencaoEstado;
        this.OblOrdemintervencaoAlteracaoestado = OblOrdemintervencaoAlteracaoestado;
        this.AuthenticationService = AuthenticationService;
    }
    table(query) {
        return this.OblOrdemintervencao.table(query).$promise;
    }
    changeState(id, atual, estado, observacoes) {
        return this.OblOrdemintervencaoAlteracaoestado.create({
            id: 0,
            oiId: id,
            funcionarioId: this.AuthenticationService.getId(),
            dataAlteracao: moment().format(),
            estadoInicial: atual,
            estadoFinal: estado,
            observacoes: observacoes,
            active: 1
        }).$promise;
    }
    states() {
        return this.OblOrdemintervencaoEstado.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise;
    }
    details(id) {
        return this.OblOrdemintervencao.findOne({
            filter: {
                where: {
                    id
                },
                include: [
                    'Estado',
                    'Cliente',
                    {
                        relation: 'Processos',
                        scope: {
                            include: ['Estado', 'Valencia'],
                            order: ['id DESC']
                        }
                    },
                    {
                        relation: 'Historico',
                        scope: {
                            include: ['Funcionario', 'EstadoFinal']
                        }
                    }
                ]
            }
        }).$promise;
    }
}
OblOiService.$inject = ['OblOrdemintervencao', 'OblOrdemintervencaoEstado', 'OblOrdemintervencaoAlteracaoestado', 'AuthenticationService'];
